import React from 'react';
import { Contenedor, CuadroColor } from './Referencias.style';
import { referencias as valores } from './valores';

function Referencias() {
    const { referencias } = valores
    return (
        referencias.map((referencia,key) => {

            return (
                <Contenedor key={key}>
                    <CuadroColor style={{
                        backgroundColor: referencia.color,

                    }}>

                    </CuadroColor>
                    <div>  Riesgo {referencia.nombre} </div>
                </Contenedor>
            )
        })
    );
}





export default Referencias